import React from 'react';
import {connect} from 'react-redux'
import {branch, compose, renderComponent} from 'recompose'
import {referralListActions, referralListSelectors} from './redux'
import {sessionSelectors} from '../session/redux'
import {careUnitActions, careUnitSelectors} from '../careUnit/redux'
import lifeCycle from './ReferralListLifecycle'
import ReferralList from "./ReferralList";
import Loading from '../../components/Loading'
import {opticianActions, opticianSelectors} from "../optician/redux";

const mapStateToProps = (state) => ({
    referrals: referralListSelectors.referralList(state),
    careUnits: careUnitSelectors.careUnitList(state),
    opticians: opticianSelectors.opticianList(state),
    loggedInUser: sessionSelectors.loggedInUser(state),
    userRole: sessionSelectors.role(state),
    userOrganizationId: sessionSelectors.organizationId(state),
    errorMessage: referralListSelectors.errorMessage(state),
    isLoading: referralListSelectors.isLoading(state),
    selectedReferralId: referralListSelectors.selectedReferralId(state),
    referralDetails: referralListSelectors.referralDetails(state),
    detailsLoading: referralListSelectors.detailsLoading(state),
    detailsError: referralListSelectors.detailsError(state),
    referralContent: referralListSelectors.referralContent(state),
    contentLoading: referralListSelectors.contentLoading(state),
    contentError: referralListSelectors.contentError(state),
    detailsDialogOpen: referralListSelectors.detailsDialogOpen(state),
    currentPage: referralListSelectors.currentPage(state),
    totalPages: referralListSelectors.totalPages(state),
    totalElements: referralListSelectors.totalElements(state),
});

const mapDispatchToProps = (dispatch) => ({
    listCareUnits: () => dispatch(careUnitActions.listCareUnits()),
    listOpticians: () => dispatch(opticianActions.listOpticians()),
    searchPersonnummer: (personnummer, careUnitId) => dispatch(referralListActions.searchReferrals(personnummer, careUnitId)),
    refreshStatus: (referralId) => dispatch(referralListActions.refreshReferralStatus(referralId)),
    listReferrals: (careUnitId, opticianId, page) => dispatch(referralListActions.listReferrals(careUnitId, opticianId, page)),
    openReferralDetailsDialog: (referralId) => dispatch(referralListActions.openReferralDetailsDialog(referralId)),
    closeDialogs: () => dispatch(referralListActions.closeDialogs()),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifeCycle,
    branch(({isLoading}) => isLoading,
        renderComponent(() => <Loading title={'Laddar...'}/>)
    )
)(ReferralList)